const options = {
  xs: "lg:max-w-xs",
  sm: "lg:max-w-sm",
  md: "lg:max-w-md",
  lg: "lg:max-w-lg",
  xl: "lg:max-w-xl",
  "2xl": "lg:max-w-2xl",
  "3xl": "lg:max-w-3xl",
  "4xl": "lg:max-w-4xl",
  "5xl": "lg:max-w-5xl",
  "6xl": "lg:max-w-6xl",
  "7xl": "lg:max-w-7xl",
  none: "lg:max-w-none",
};

export default function getMaxWidthLg(width) {
  return options[width];
}
